import React, { Component } from 'react';

import SvgIcon from './svg-icon.jsx';

class SlowConnectionBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorText: this.props.errorText,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.errorText !== this.props.errorText) {
      this.setState({
        errorText: this.props.errorText
      });
    }
  }

  render() {
    return (
      <div className="slow-connection-notice-banner" aria-label="Connection Notice">
        <div className="slow-connection-notice-text">
          <SvgIcon name="warning" viewBox="0 0 17 17" width={17} height={17}
            className="slow-connection-notice-icon" />
          <span>{this.state.errorText}</span>
        </div>
      </div>
    );
  }
}

export default SlowConnectionBanner;
